module.exports = "/_next/static/images/powerServices-53eee7aa0061c2c27118c09deb1f56b4.webp";